<div class="your-order-info"
     [class.payment-intent-view]="isPaymentIntentView">
  <div class="info-block">
    @if (showHeader) {
      <div class="info-block-header">
        <div>
          @if (isPaymentIntentView) {
            <span class="font-lg fw-bold">
              {{ 'paymentIntent.title' | translate: { number: order.number } }}
            </span>
          } @else {
            <span class="font-lg fw-bold"
                  [translate]="'receipt.yourOrder'">
            </span>
          }
          <ng-content select=".order-info-header-table"></ng-content>
        </div>

        <div class="font-md">
          <span [translate]="'common.order.time'"></span>:&nbsp;
          {{ order.multiOrder.payment.capturedDate | i18nDate: 'DD.MM.YY HH:mm' }}
        </div>
      </div>
    }


    <div class="info-block-content"
         [class.pb-0]="showDeliveryFooter && hasDeliveryDetails">
      <table class="info-block-table receipt-order-table">
        <thead>
        <tr>
          <th class="info-block-table-th font-xxxs" [translate]="'receipt.product'"></th>
          <th class="info-block-table-th font-xxxs text-center px-2" [translate]="'receipt.quantity'"></th>
          <th class="info-block-table-th font-xxxs text-center px-2" [translate]="'receipt.unitPrice'"></th>
          <th class="info-block-table-th font-xxxs text-end ps-2" [translate]="'receipt.sum'"></th>
        </tr>
        </thead>

        @for (orderLine of orderLines; track orderLine.id) {
          <tbody
            class="font-md order-line"
            product-tbody
            [orderLine]="orderLine"
            [currency]="bakeryCurrency.symbol"
          ></tbody>

          @for (subOrderLine of orderLine.orderLines; track subOrderLine.trackId || subOrderLine.id) {
            @if (subOrderLine.type === CART_LINE_TYPES.GROUPED_EXTRA_PRODUCTS) {
              <tbody
                class="font-md"
                grouped-extra-product-tbody
                [orderLine]="subOrderLine"
                [currency]="bakeryCurrency.symbol"
              ></tbody>
            }

            @if (subOrderLine.type !== CART_LINE_TYPES.GROUPED_EXTRA_PRODUCTS &&
            subOrderLine.type !== CART_LINE_TYPES.INTERNAL_COMMENT &&
            subOrderLine.state !== ORDER_LINE_STATES.DELETED) {
              <tbody
                class="font-md"
                extra-product-tbody
                [orderLine]="subOrderLine"
                [currency]="bakeryCurrency.symbol"
              ></tbody>
            }
          }
        }

        @if (invoiceFeeOrderLine) {
          <tbody class="order-line font-md">
          <tr class="fw-bold">
            <td>{{ invoiceFeeOrderLine.name }}</td>
            <td class="text-end" colspan="3">
              {{ invoiceFeeOrderLine.price | currencyFormat: bakeryCurrency.symbol }}
            </td>
          </tr>
          </tbody>
        }

        @if (deliveryPrice) {
          <tbody class="font-sm order-line">
          <tr>
            <td [translate]="'receipt.delivery'"></td>
            <td colspan="3" class="text-end">
              {{ deliveryPrice | currencyFormat: bakeryCurrency.symbol }}
            </td>
          </tr>
          </tbody>
        }

        @if (returnPackagingOrderLine) {
          <tbody class="font-sm order-line">
          <tr>
            <td>
              <div class="text-bold"
                   [translate]="returnPackagingOrderLine.returnPackaging.returnMethod === RETURN_METHODS.SELF
                     ? 'receipt.returnPackaging.selfReturn'
                     : 'receipt.returnPackaging.courierReturn'">
              </div>

              <span class="first-letter-capitalize d-inline-block">
                {{ returnPackagingOrderLine.returnPackaging.scheduledDate | i18nDate: 'dddd D MMM' }}
              </span>
              {{ returnPackagingOrderLine.returnPackaging.scheduledTime }}
            </td>

            <td colspan="3" class="text-end valign-top">
              {{ returnPackagingOrderLine.price | currencyFormat: bakeryCurrency.symbol }}
            </td>
          </tr>
          </tbody>
        }

        <tbody
          class="font-sm order-line"
          order-discount-tbody
          [isCustomerView]="isCustomerView"
          [order]="order"
          [invoiceFeeOrderLine]="invoiceFeeOrderLine"
        ></tbody>
      </table>

      @if (!showDeliveryFooter || !hasDeliveryDetails) {
        @if (isPaymentIntentView) {
          <ng-container *ngTemplateOutlet="paymentIntentSummaryWithPaddings"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="orderInfoSummaryWithPaddings"></ng-container>
        }
      }
    </div>

    @if (showDeliveryFooter && hasDeliveryDetails) {
      <div class="default-panel receipt-delivery">
        @if (deliveryOrder.type === CART_DELIVERY_TYPES.DELIVERY) {
          <order-info-delivery
            [deliveryOrder]="deliveryOrder"
            [showDeliveryEdit]="showDeliveryEdit"
            (onDeliveryEdit)="onDeliveryEdit.emit()">
            <ng-container *ngTemplateOutlet="deliveryInfoContent"></ng-container>
          </order-info-delivery>
        }

        @if (deliveryOrder.type === CART_DELIVERY_TYPES.PICKUP) {
          <order-info-pickup
            [order]="order"
            [deliveryOrder]="deliveryOrder"
            [showDeliveryEdit]="showDeliveryEdit"
            (onDeliveryEdit)="onDeliveryEdit.emit()"
            (onShowMap)="onShowMap.emit()">
            <ng-container *ngTemplateOutlet="deliveryInfoContent"></ng-container>
          </order-info-pickup>
        }
      </div>
    }

  </div>
</div>


<ng-template #deliveryInfoContent>
  @if (isPaymentIntentView) {
    <ng-container *ngTemplateOutlet="paymentIntentSummary"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="orderInfoSummary"></ng-container>
  }
</ng-template>

<ng-template #paymentIntentSummaryWithPaddings>
  <div class="d-block p-sm-max-2 mt-sm-max-2 mt-3">
    <ng-container *ngTemplateOutlet="paymentIntentSummary"></ng-container>
  </div>
</ng-template>

<ng-template #paymentIntentSummary>
  <payment-intent-summary
    [currency]="bakeryCurrency.total"
    [paymentIntent]="paymentIntent"
  ></payment-intent-summary>
</ng-template>

<ng-template #orderInfoSummaryWithPaddings>
  <div class="d-block p-sm-max-2 mt-sm-max-2 mt-3">
    <ng-container *ngTemplateOutlet="orderInfoSummary"></ng-container>
  </div>
</ng-template>

<ng-template #orderInfoSummary>
  <order-info-summary
    [order]="order"
    [currency]="bakeryCurrency.total"
    [isCustomerView]="isCustomerView"
  ></order-info-summary>
</ng-template>
